var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')


var {
  KeyboardAvoidingView,
  DeviceEventEmitter,
  Platform,
} = ReactNative;
var Keyboard = DeviceEventEmitter;
var Overlay = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
    }
  },

  getInitialState : function()
  {
    return {
      keyboardOffset : new Animated.Value(0)
    }
  },

  componentDidMount : function()
  {
    this.mounted = true;
    // DeviceEventEmitter.addListener('keyboardDidShow', this._keyboardWillShow.bind(this))
    // DeviceEventEmitter.addListener('keyboardDidHide', this._keyboardWillHide.bind(this))
  },

  componentWillUnmount : function()
  {
    this.mounted = false;
  },

  _keyboardWillShow : function(e)
  {
    if( !this.mounted ) return;

    Animated.spring(this.state.keyboardOffset,
    {
      toValue: e.endCoordinates.height,
      friction: 6
    }).start();
  },

  _keyboardWillHide : function(e)
  {
    if( !this.mounted ) return;

    Animated.spring(this.state.keyboardOffset,
    {
      toValue: 0,
      friction: 6
    }).start();
  },

  render: function()
  {
    var {style, ...other} = this.props;

    if( Platform.OS === 'ios' )
    {
        return <KeyboardAvoidingView behavior={"padding"} style={[{position:'absolute', top:0, left:0, right:0, bottom:0}, style]} {...other} />
    }
    else
    {
      return <Animated.View style={[{position:'absolute', top:0, left:0, right:0, bottom:this.state.keyboardOffset}, style]} {...other} />
    }

  }
});

module.exports = Overlay;
